import { Box, Card, ListItemText, CardMedia, Container, List, ListItem, Typography, CardContent, Divider } from "@mui/material";

import Grid from '@mui/material/GridLegacy'
import React, { useEffect } from "react";
import backimg from "../assets/image/backgroundabout.jpg";
import pratham from '../assets/image/about3.jpg'
import dev from '../assets/image/about1.jpg';
import kenny from '../assets/image/about2.jpg';
import groupwomen from '../assets/image/groupwomen.jpg'
import mission from '../assets/image/mission.png';
import vission from '../assets/image/vision.png';
import purpose from '../assets/image/purpose.png';
import abouttop from '../assets/image/abouttop.png'
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import Slider from "../component/slider";
const About = () => {

  const data = [
    {
      title: "Transparent Advice",
      mentor: {
        status: true,
        text: "No commissions, unbiased opinions",
      },
      agency: {
        status: false,
        text: "Often driven by commissions",
      },
    },
    {
      title: "Lived Experience",
      mentor: {
        status: true,
        text: "Real advice from those who’ve been through the system",
      },
      agency: {
        status: false,
        text: "Lack firsthand experience",
      },
    },
    {
      title: "Cost-Effective",
      mentor: {
        status: true,
        text: "No consultation fees or hidden charges",
      },
      agency: {
        status: false,
        text: "Often include hidden costs",
      },
    },
    {
      title: "Flexible",
      mentor: {
        status: true,
        text: "Book based on your schedule and needs",
      },
      agency: {
        status: false,
        text: "Fixed appointments and sales targets",
      },
    },
    {
      title: "Trustworthy",
      mentor: {
        status: true,
        text: "Verified student mentors with real stories",
      },
      agency: {
        status: false,
        text: "Mixed credibility and marketing-driven",
      },
    },
  ];
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Whether animation should happen only once
    });
  })
  return (
    <>
      <Grid container spacing={4} sx={{
        backgroundColor: "#93b1b5",
        overflow: "hidden",
        paddingTop: {
          xs: "100px", // For extra small screens
          sm: "120px", // Optional: for larger screens
        },
      }} >
        <Grid item xs={12} sm={8} md={7} mt={4} mb={4}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: { xs: 'auto', sm: '300px' }, 
            paddingLeft: { xs: '0px', sm: '30px' } }}
          >
            <motion.div
              initial={{ y: "-100vh", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1.8, ease: "easeOut" }}
            >
              <Typography data-aos="fade-down" variant="h1" mb={6} sx={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                lineHeight: "1.2",
                color: "White",
                fontSize: {
                  xs: "2rem",
                  sm: "1rem",
                  md: "1.4rem",
                  lg: "1.4rem",
                  xl: "3.5rem",
                },
              }}>Why We Exist
              </Typography>
              <Typography data-aos="fade-right"
                variant="h5"
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 700,
                  lineHeight: "1.2",
                  color: "grey",
                  fontSize: {
                    xs: "1.4rem",
                    sm: "1rem",
                    md: "1.4rem",
                    lg: "1.4rem",
                    xl: "2.5rem",
                  },
                }}
              >
                We believe every student deserves the chance to succeed globally{" "}
                <Box
                  component="span"
                  sx={{
                    color: "#2B4F60",
                    fontWeight: 500,
                    fontSize: {
                      xs: "1rem",
                      sm: "1rem",
                      md: "1.4rem",
                      lg: "1.4rem",
                      xl: "2rem",
                    },
                  }}
                >
                  — with the right guidance.
                  From first step to final admission, we connect you with real mentors, accurate information, and a supportive community.
                  Our mission? Your success abroad.
                </Box>
              </Typography>
            </motion.div>
          </Box>
        </Grid>

        {/* Right Side: Slider with vertical spacing */}
        <Grid
          item
          xs={12}
          mt={7} mb={7}
          sm={4}
          md={4}
          sx={{
            pt: { xs: 2, sm: 4 }, // Top padding
            pb: { xs: 2, sm: 4 },
            marginRight: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
            marginLeft: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            }, // Bottom padding
            paddingLeft: {
              // xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
            // paddingRight: "50px",
          }}
        >
          <Slider image1={dev} image2={kenny} image3={pratham} />
        </Grid>
      </Grid>
      <Container
        maxWidth="xxl"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginTop: '50px',
          marginBottom: '10px',
          justifyContent: 'space-between', // Creates space between left and right items
          padding: {
            xs: '20px', // Smaller padding for mobile devices
            sm: '30px', // Medium padding for small devices
            md: '40px', // Larger padding for medium devices
            lg: '50px', // Larger padding for large devices
            xl: '50px'  // Consistent padding for extra-large devices
          }
        }}
      >
        <Grid container spacing={5} sx={{ textAlign: 'center' }}>
          {/* Heading section */}
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "70px",
              paddingX: { xs: "10px", sm: "20px", md: "30px" }, // Responsive padding for left and right
              textAlign: "center", // Center the text within the grid
              maxWidth: "100%", // Ensures the grid item doesn't exceed the container width
              flexWrap: "wrap", // Allows the text to wrap on smaller screens
              overflow: "hidden", // Prevents overflow

            }}
          >
            <Typography data-aos="fade-up"
              variant='h3'
              sx={{
                color: "#2B4F60", marginRight: "5px", flexShrink: 0, fontFamily: "Poppins, sans-serif", fontWeight: "500", fontSize: {
                  xs: "2.2rem",
                  sm: "3rem",
                  md: "2.7rem",
                  lg: "3.1rem",
                  xl: "3.5rem",
                }
              }} // Prevent shrinking
            >
              OUR <span style={{ color: "#23a8e1", flexShrink: 0, fontFamily: "Poppins, sans-serif", fontWeight: "500" }}>BENEFITS</span>
            </Typography>
          </Grid>

          {/* Paragraph section */}
          <Grid item xs={12} sx={{ padding: { xs: '0 10px', sm: '0 20px', md: '0 30px' }, textAlign: "center" }}>
            <Typography data-aos="fade-down"
              component='p'
              // className='poppins-regular'
              sx={{
                fontSize: {
                  xs: "1rem",
                  sm: "1.4rem",
                  md: "1.5rem",
                  lg: "1.1rem",
                  xl: "1.5rem",
                },
                color: "black",
                margin: '0 auto',
                fontFamily: "Poppins, sans-serif", fontWeight: {
                  xl: "350",
                  lg: "400",
                  sm: "300",
                  xs: "350",
                  md: "400" // Adjust for medium screens
                },
                lineHeight: "Poppins, sans-serif", lineHeight: {
                  xl: "2.5rem",
                  lg: "2.3rem",
                  sm: "2.3rem",
                  xs: "1.7rem",
                  md: "2.4rem" // Adjust for medium screens
                },
                // Center the text block
                // maxWidth: 'auto' // Limit width for better readability
              }}
            >
              GET MENTORS ensures that you receive honest, real-world guidance from students who have successfully navigated the study abroad journey. Unlike agencies, our mentors don’t push specific universities but instead offer personalized support tailored to your needs. From university selection and visa applications to scholarships and career planning, we help you make informed decisions at every step. With no hidden fees, you gain access to cost-effective solutions, networking opportunities, and practical advice to simplify your transition and maximize your success abroad.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Container
        maxWidth="xxl"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "50px",
          marginBottom: "10px",
          backgroundColor: "aliceblue",
          padding: { xs: "20px", sm: "30px", md: "40px", lg: "50px", xl: "50px" },
        }}
      >
        <Grid container spacing={4} alignItems="stretch" overflow="hidden">

          <Grid item lg={5} md={6} sm={5} xs={12} xl={4} sx={{ display: "flex", justifyContent: "center", alignSelf: "stretch" }}>
            <Card data-aos="fade-up-right" sx={{ boxShadow: "none", backgroundColor: "transparent", width: "80%", height: "100%" }}>
              <CardMedia
                component="img"
                image={groupwomen}
                alt="Group of Women"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "15px",
                  borderBottomLeftRadius: "70px",
                }}
              />
            </Card>
          </Grid>

          <Grid
            item data-aos="fade-left"
            xl={8}
            lg={7}
            md={6}
            sm={7}
            xs={12}
            sx={{
              textAlign: { xs: "center", md: "left" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "left"
            }}
          >
            <Typography variant="h5" sx={{
              color: "#333", fontSize: {
                xs: '1.2rem', // Smaller padding for mobile devices
                sm: '1.4rem', // Medium padding for small devices
                md: '1.4rem', // Larger padding for medium devices
                lg: '1.2rem', // Larger padding for large devices
                xl: '2rem'
              }, fontWeight: "400", marginBottom: 1, fontFamily: "Poppins, sans-serif"
            }}>
              Guiding Dreams, Shaping Futures
            </Typography>
            <Typography variant="h3" sx={{
              color: "#333", fontSize: {
                xs: '1.5rem', // Smaller padding for mobile devices
                sm: '1.6rem', // Medium padding for small devices
                md: '1.7rem', // Larger padding for medium devices
                lg: '1.5rem', // Larger padding for large devices
                xl: '2.5rem'
              }, fontWeight: "500", marginBottom: 2, fontFamily: "Poppins, sans-serif"
            }}>
              Small decisions shape great futures. Let experience guide your journey.
            </Typography>
            <Typography variant="body2" sx={{
              color: "#555", fontSize: {
                xs: '1rem', // Smaller padding for mobile devices
                sm: '0.9rem', // Medium padding for small devices
                md: '1rem', // Larger padding for medium devices
                lg: '1.2rem', // Larger padding for large devices
                xl: '1.8rem'
              }, lineHeight: 1.6, fontFamily: "Poppins, sans-serif", fontWeight: "300"
            }}>
              Navigating the study abroad process can be overwhelming, but with the right guidance, every step becomes easier. Our mentorship community ensures that students receive practical advice, helping them avoid mistakes and make informed choices.
            </Typography>
            <List
              sx={{
                display: "flex",
                flexWrap: "wrap",
                marginTop: 2,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {[
                "Campaign launch and goals",
                "In-depth insights",
                "More awareness and visibility",
                "Performance reports",
                "ROI measurement and analysis",
                "Personalized marketing plans",
              ].map((text, index) => (
                <ListItem
                  key={index}
                  disableGutters
                  sx={{
                    padding: "5px 0",
                    width: { xs: "100%", sm: "50%" }, // Full width on mobile, 2 columns on larger screens
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Poppins, sans-serif !important",
                  }}
                >
                  <CheckCircleIcon sx={{ color: "green", marginRight: 1 }} />
                  <ListItemText
                    primary={text}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "Poppins, sans-serif",
                        fontSize: {
                          xs: "0.8rem",
                          sm: "0.7rem",
                          md: "0.8rem",
                          lg: "0.8rem",
                          xl: "1.9rem",
                        },
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>

          </Grid>
        </Grid>
      </Container>
      <Container maxWidth='xxl' sx={{ marginTop: "50px", marginBottom: "80px" }}>
        <Grid container spacing={6} sx={{ display: "flex", paddingLeft: {
             xs: "0px",
              sm: "50px"
        } 

          
        }}>

          <Grid data-aos="fade-up-right" item lg={6} md={5}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0,
              textAlign: "left",
              pl: 6,

            }}
          >

            <Typography variant="h3" sx={{
              fontFamily: "Poppins,sans-serif ", fontWeight: "500 !important", lineHeight: 1.2, mb: "15px", pt: "40px", color: "#2B4F60", fontSize: {
                xs: "1.9rem",
                sm: "2rem",
                md: "2rem",
                lg: "1.8rem",
                xl: "3rem",
              },
            }}>
              Empowering students through mentorship, <span style={{ color: "#23a8e1" }}>experience, and real-world guidance</span>
            </Typography>

            <Typography variant="body2" sx={{
              margin: 0, lineHeight: 1.5, fontFamily: "Poppins, sans-serif", fontWeight: "300", fontSize: {
                xs: "1.1rem",
                sm: "1.5rem",
                md: "1.1rem",
                lg: "1rem",
                xl: "1.2rem",
              }
            }}>
              We believe in the power of shared experiences. Our mentorship community connects aspiring students with those who have already walked the path of studying abroad. By providing honest insights and practical advice, we help students navigate their journey with confidence.
            </Typography>
          </Grid>

          <Grid container item lg={6} md={7} sx={{ display: "flex" }} spacing={6}>
            <Grid item lg={6} md={6} sm={6} sx={{ alignSelf: "stretch" }}>
              <Card data-aos="fade-up" sx={{
                boxShadow: "0px 4px 15px #23a8e1",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                "&:hover": { transform: "translateY(-5px)", transition: "0.3s ease-in-out" }
              }}>
                <CardMedia
                  component="img"
                  image={mission}
                  alt="Mission Icon"
                  sx={{ width: 50, height: 50, margin: "10px", pl: "10px" }}
                />
                <CardContent sx={{ textAlign: "left", flexGrow: 1 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "500",
                      fontSize: {
                        xs: "1.1rem",
                        sm: "1.5rem",
                        md: "1.1rem",
                        lg: "2.5rem",
                        xl: "3rem",
                      },
                      position: "relative",
                      display: "inline-block",
                      "&::after": {
                        content: '""',
                        display: "block",
                        width: "50%", // Half underline
                        height: "3px",
                        backgroundColor: "#23a8e1",
                        marginTop: "5px",
                      }
                    }}
                  >
                    Mission
                  </Typography>
                  <Typography variant="body1" sx={{ fontFamily: "Poppins, sans-serif", fontWeight: "400", mt: "10px" }}>
                    To build a student-led mentorship network that simplifies the study abroad journey through real-world guidance.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item lg={6} md={6} sm={6} sx={{ alignSelf: "stretch" }}>
              <Card data-aos="fade-up" sx={{
                boxShadow: "0px 4px 15px #23a8e1",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                "&:hover": { transform: "translateY(-5px)", transition: "0.3s ease-in-out" }
              }}>
                <CardMedia
                  component="img"
                  image={vission}
                  alt="Vision Icon"
                  sx={{ width: 50, height: 50, margin: "5px", pl: "10px" }}
                />
                <CardContent sx={{ textAlign: "left", flexGrow: 1 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "500",
                      position: "relative",
                      fontSize: {
                        xs: "1.1rem",
                        sm: "1.5rem",
                        md: "1.1rem",
                        lg: "2.5rem",
                        xl: "3rem",
                      },
                      display: "inline-block",
                      "&::after": {
                        content: '""',
                        display: "block",
                        width: "50%",
                        height: "3px",
                        backgroundColor: "#23a8e1",
                        marginTop: "5px",
                      }
                    }}
                  >
                    Vision
                  </Typography>
                  <Typography variant="body1" sx={{ fontFamily: "Poppins, sans-serif", fontWeight: "400", mt: "10px" }}>
                    To become the world’s most trusted student mentorship platform for international education.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item lg={12} md={12} sx={{ alignSelf: "stretch" }}>
              <Card data-aos="fade-up" sx={{
                boxShadow: "0px 4px 15px #23a8e1",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                "&:hover": { transform: "translateY(-5px)", transition: "0.3s ease-in-out" }
              }}>
                <CardMedia
                  component="img"
                  image={purpose}
                  alt="Purpose Icon"
                  sx={{ width: 50, height: 50, margin: "10px", pl: "10px" }}
                />
                <CardContent sx={{ textAlign: "left", flexGrow: 1 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "500",
                      position: "relative",
                      fontSize: {
                        xs: "1.1rem",
                        sm: "1.5rem",
                        md: "1.1rem",
                        lg: "2.5rem",
                        xl: "3rem",
                      },
                      display: "inline-block",
                      "&::after": {
                        content: '""',
                        display: "block",
                        width: "50%",
                        height: "3px",
                        backgroundColor: "#23a8e1",
                        marginTop: "5px",
                      }
                    }}
                  >
                    Purpose
                  </Typography>
                  <Typography variant="body1" sx={{ fontFamily: "Poppins, sans-serif", fontWeight: "400", mt: "10px" }}>
                    •  To connect experienced students with aspiring ones and help them succeed with confidence.
                  </Typography>
                  <Typography variant="body1" sx={{ fontFamily: "Poppins, sans-serif", fontWeight: "400" }}>
                    • To simplify the study abroad journey with firsthand knowledge.
                  </Typography>
                  <Typography variant="body1" sx={{ fontFamily: "Poppins, sans-serif", fontWeight: "400" }}>
                    • To help students avoid mistakes and make the right choices for their future.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>


        </Grid>
      </Container>
      <Typography data-aos="fade-right"
        variant="h2"
        sx={{
          marginTop: "50px",
          marginBottom: "10px",
          fontFamily: "Poppins, sans-serif",
          color: "#2B4F60",
          fontSize: {
            xs: "1.9rem",
            sm: "2.2rem",
            md: "2.8rem",
            lg: "3rem",
            xl: "4.2rem",
          },
          fontWeight: {
            xs: "50",
            sm: "520",
            md: "530",
            lg: "500",
            xl: "600",
          }

        }}
      >
        Why Choose
        <span style={{ color: "#32de84" }}> Mentoring
        </span> Over
        <span style={{ color: "#fd5c63" }}>  Agencies?</span>
      </Typography>
      <Card container
        sx={{
          // width: "100%",
          // maxWidth: { xs: "100%"}, // Full width on xs, fixed width on larger screens
          margin: "auto",
          boxShadow: "0px 4px 15px rgba(0,0,0,0.2)",
          borderRadius: 3,
          mb: "50px",
          overflow: "hidden",
          margin:"20px"
        }}
      >



        <CardContent  >
          <Grid container spacing={0} alignItems="center" textAlign="center" >

            <Grid item xs={12} sm={4} sx={{ p: { xs: 1, sm: 2 } }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", fontFamily: "Poppins, sans-serif" }}>
                Feature
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sm={4}
              sx={{
                backgroundColor: "#F7F7F7",
                py: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: "#007bff",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                Get Mentor 😊
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4} sx={{ p: { xs: 1, sm: 2 } }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", fontFamily: "Poppins, sans-serif" }}>
                Agencies
              </Typography>
            </Grid>


            {data.map((item, index) => (
              <Grid container key={index} sx={{ borderTop: "1px solid #ddd", textAlign: "center" }}>


                <Grid item xs={12} sm={4} sx={{ p: { xs: 1, sm: 2 }, display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                  <Typography variant="body1" sx={{ fontWeight: "500", py: 1, fontFamily: "Poppins, sans-serif" }}>
                    {item.title}
                  </Typography>
                </Grid>


                <Grid
                  item
                  xs={12}
                  sm={4}
                  sx={{
                    backgroundColor: "#F7F7F7",
                    py: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {item.mentor.status ? (
                      <CheckIcon sx={{ color: "white", background: "#32de84", borderRadius: "5px", padding: "4px", fontSize: 18 }} />
                    ) : (
                      <CloseIcon sx={{ color: "white", background: "#fd5c63", borderRadius: "5px", padding: "4px", fontSize: 18 }} />
                    )}
                    <Typography variant="body2" sx={{ fontFamily: "Poppins, sans-serif", textAlign: "left" }}>
                      {item.mentor.text}
                    </Typography>
                  </Box>
                </Grid>


                <Grid
                  item
                  xs={12}
                  sm={4}
                  sx={{
                    py: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {item.agency.status ? (
                      <CheckIcon sx={{ color: "white", background: "#32de84", borderRadius: "5px", padding: "4px", fontSize: 18 }} />
                    ) : (
                      <CloseIcon sx={{ color: "white", background: "#fd5c63", borderRadius: "5px", padding: "4px", fontSize: 18 }} />
                    )}
                    <Typography variant="body2" sx={{ fontFamily: "Poppins, sans-serif", textAlign: "left" }}>
                      {item.agency.text}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ))}

          </Grid>
        </CardContent>
      </Card>



    </>


  );
};

export default About;
